import Select from './src/select';

/* 注册全局组件 */
Select.install = Vue => {
  Vue.component(Select.name, Select);
}

export default Select;
